import { T } from '../domaine/libelles'
import { surEvenement } from '../noyau/bus'
import { lireReglage } from '../noyau/db'
import { etatFile } from '../noyau/file'
import { ancienneteMinutes, el, heure, requis, vider } from './dom'

/*
  Bandeau de persistance.

  Deux informations, tout le temps visibles : la saisie est gardée sur
  l'appareil, et voilà ce qui reste à partir. Jamais d'excuse, jamais d'erreur.
*/

async function rendre(): Promise<void> {
  const noeud = requis('bandeau-file')
  const etat = await etatFile()
  const dernier = await lireReglage('dernier_envoi_ok')

  const morceaux: string[] = []

  if (etat.enAttente > 0) {
    morceaux.push(`${etat.enAttente} ${T.enFile}`)
    if (etat.plusAncien) {
      morceaux.push(`${ancienneteMinutes(etat.plusAncien)} MIN`)
    }
  } else {
    morceaux.push(T.toutEnvoye)
    if (dernier) morceaux.push(heure(new Date(dernier)))
  }

  if (etat.enQuarantaine > 0) {
    morceaux.push(`${etat.enQuarantaine} ${T.enAttenteDeReprise}`)
  }

  vider(noeud)
  noeud.append(
    el('span', { class: 'bandeau-file__gauche', text: T.gardeSurAppareil }),
    el('span', {
      class:
        etat.enAttente > 0 || etat.enQuarantaine > 0
          ? 'bandeau-file__droite bandeau-file__droite--attente'
          : 'bandeau-file__droite',
      text: morceaux.join(' · '),
    }),
  )
}

export function demarrerBandeauFile(): void {
  void rendre()
  surEvenement('file-changee', () => void rendre())
  // L'ancienneté du plus ancien élément vieillit toute seule.
  setInterval(() => void rendre(), 30_000)
}
